import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 20px 10px 20px;
  position: relative;
  width: 450px;
  transition: transform 0.2s;

  @media (max-width: 930px) {
    max-width: 430px;
    padding-left: 10px;
  }
  @media (max-width: 480px) {
    max-width: 350px;
  }

  @media (max-width: 380px) {
    max-width: 300px;
  }
  @media (max-width: 310px) {
    max-width: 250px;
  }
`;

export const Content = styled.div`
  box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 14px 8px 14px 0;
  width: 420px;
  height: 130px;
  background: ${({ theme }) => theme.backgroundCard};
  display: flex;
  align-items: center;

  > span {
    min-width: 110px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      min-height: 80px;
      width: 80px;
    }
  }

  div {
    height: 100%;

    span {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      max-width: 300px;

      h1 {
        line-height: 30px;
        font-size: 1.25rem;
        font-weight: 600;
        margin: 0;
        color: ${({ theme }) => theme.text};
      }

      p {
        line-height: 25px;
        font-weight: 500;
        font-size: 1rem;
        color: ${({ theme }) => theme.text};
      }
    }
  }

  @media (max-width: 480px) {
    width: 350px;
  }

  @media (max-width: 400px) {
    width: 300px;
    > span {
      img {
        height: 60px;
      }
    }
    div {
      min-width: 125px;
    }
  }

  @media (max-width: 350px) {
    width: 280px;

    > span {
      display: none;
    }

    > div {
      margin-left: 1.5rem;
    }
  }

  @media (max-width: 310px) {
    width: 230px;
    height: 130px;
    div {
      span {
        h1 {
          font-size: 1.5rem;
        }
        h2 {
          font-size: 1rem;
        }
      }
      div {
        min-width: 125px;
      }
    }
  }

  > span {
    width: 80px;
    img {
      height: 50px;
    }
  }
`;
